import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Checkbox from "./Checkbox";
import Style from "style-it";
import SearchField from "../../Components/common/SearchField";
import "react-toastify/dist/ReactToastify.css";
import Scrollbar from "react-scrollbars-custom";
import instance from "../../axios";

const AccountSelector = (props) => {
  const [search, setSearch] = useState("");
  const [vehicles, setVehicles] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [list, setList] = useState({});
  const [usersId, setUsersId] = useState({});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    getAccounts();
  }, [search]);

  useEffect(() => {
    if (props.value?.length || props.value2?.length) {
      const newList = {};
      const newUsers = {};
      props.value?.forEach((d) => (newList[d] = true));
      props.value2?.forEach((d) => (newUsers[d] = true));
      setList(newList);
      setUsersId(newUsers);
    }
  }, [props.value, props.value2]);

  useEffect(() => {
    setIsChecked(false);
  }, [props.tab]);

  useEffect(() => {
    return () => {
      setList({});
      setUsersId({});
      setSearch("");
      setIsChecked(false);
    };
  }, []);

  const sendToParent = (listData = list, userIdData = usersId) => {
    props.onChange?.(Object.keys(listData), Object.keys(userIdData));
  };

  const handleChange = (e, vehicle) => {
    const updatedList = { ...list };
    const updatedUsers = { ...usersId };

    if (e.target.checked) {
      updatedList[vehicle.contractNumber] = true;
      updatedUsers[vehicle.userId] = true;
    } else {
      delete updatedList[vehicle.contractNumber];
      delete updatedUsers[vehicle.userId];
    }

    const isAllChecked = vehicles.length > 0 &&
      vehicles.every((v) => updatedList[v.contractNumber]);

    setList(updatedList);
    setUsersId(updatedUsers);
    setIsChecked(isAllChecked);
    sendToParent(updatedList, updatedUsers);
  };

  const toggleItems = (e) => {
    const allList = {};
    const allUsers = {};

    if (e.target.checked) {
      vehicles.forEach((v) => {
        allList[v.contractNumber] = true;
        allUsers[v.userId] = true;
      });
    }

    setList(e.target.checked ? allList : {});
    setUsersId(e.target.checked ? allUsers : {});
    setIsChecked(e.target.checked);
    sendToParent(e.target.checked ? allList : {}, e.target.checked ? allUsers : {});
  };

  const getAccounts = async () => {
    if (!props.logInUser?.id) return;

    let apiUrl = "";
    const base = `/api/accounts`;
    const searchParam = `&search=${search}&limit=-1`;

    switch (props.type) {
      case "reports":
        if (props.contractType === 1) {
          apiUrl = props.reportKey === 101
            ? `${base}/list?all=true&contractType=1&contractType=3&userTypes=3&userId=${props.logInUser.id}${searchParam}`
            : `${base}/list?all=true&contractType=1&userTypes=3&userId=${props.logInUser.id}${searchParam}`;
        } else if (props.contractType === 2) {
          apiUrl = `${base}/list?all=true&userId=${props.logInUser.id}&userTypes=3&contractType=2${searchParam}`;
        }
        break;
      case "commutator":
        apiUrl = `${base}/get?userId=${props.logInUser.id}&all=true${searchParam}`;
        break;
      case "dn":
      case "invoices":
        apiUrl = `${base}/list?userId=${props.logInUser.id}&contractType=${props.contractType}&all=true&userTypes=3${searchParam}`;
        break;
      case "ai-pms":
        apiUrl = `${base}/list?all=true&contractType=1&userTypes=3&userId=${props.logInUser.id}${searchParam}`;
        break;
      default:
        apiUrl = `${base}/get?userId=${props.logInUser.id}&contractType=${props.contractType}&all=true${searchParam}`;
    }

    try {
      const res = await instance.get(apiUrl);
      setVehicles(res.data);
      setLoader(false);

      if (props.sendAll || props.type === "reports") {
        const autoList = {};
        const autoUsers = {};
        res.data.forEach((d) => {
          autoList[d.contractNumber] = true;
          autoUsers[d.userId] = true;
        });
        setList(autoList);
        setUsersId(autoUsers);
        setIsChecked(true);
        sendToParent(autoList, autoUsers);
      }
    } catch (error) {
      setLoader(false);
      console.error("Failed to fetch accounts:", error);
    }
  };

  return loader ? (
    <h3>Loading...</h3>
  ) : (
    <Style>
      {`
        .selector-list li > label.active,
        .selector-list li > label:hover {}
        .selector-list li {
          margin-bottom: 6px
        }
        .selector-list li > label {
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 2px 6px;
          border-radius: 4px;
        }
        .selector-list {
          padding: 0;
          margin: 0;
          list-style: none;
        }
        .selector-label {
          font-size: 12px;
          line-height: 1.5;
          margin-left: 6px;
        }
        .selector-check {
          height: 26px;
          display: inline-flex;
          align-items: center;
        }
        .selector-count {
          padding: 0 0 6px;
          font-size: 10px;
        }`}
      <div>
        <div className="section-head clearfix section-head-filter" style={{ padding: 0, marginLeft: -6, marginRight: -2 }}>
          <ul className="filter-row pull-left">
            <li>
              <SearchField
                label={props.translate("searchAccounts")}
                type="search"
                placeholder="exp: ID, Name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                variant="outlined"
                margin="dense"
                fullWidth
              />
            </li>
          </ul>
          <Checkbox
            checked={isChecked}
            onChange={toggleItems}
            label={props.translate("selectAll")}
          />
        </div>

        <div className="selector-count">
          {Object.keys(list).length} {props.translate("AccountsSelected")}
        </div>

        <Scrollbar
          disableTracksWidthCompensation
          style={{ height: (props.minHeight ? parseInt(props.minHeight) : 35) * (props.rows || 5) }}
          scrollerProps={{
            renderer: ({ elementRef, ...restProps }) => (
              <div {...restProps} ref={elementRef} id="scrollableDiv" />
            ),
          }}
        >
          <ul className="selector-list">
            {vehicles.map((row) => (
              <li key={row.contractNumber}>
                <label className={list[row.contractNumber] ? "active" : ""}>
                  <span className="selector-check">
                    <Checkbox
                      checked={!!list[row.contractNumber]}
                      value={row.contractNumber}
                      onChange={(e) => handleChange(e, row)}
                    />
                  </span>
                  <span className="selector-label">
                    {row.name || row.accountName || row.label}
                  </span>
                </label>
              </li>
            ))}
          </ul>
        </Scrollbar>
      </div>
    </Style>
  );
};

const mapState = (state) => ({
  vehicles: state.vehicles,
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
});

export default connect(mapState)(AccountSelector);
